import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-input-number',
  imports: [CommonModule, ReactiveFormsModule, InputNumberModule, MessageModule],
  templateUrl: './input-number.component.html',
  styleUrl: './input-number.component.scss'
})
export class InputNumberComponent {

  @Input() form!: FormGroup;
  @Input() field!: string;
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() min = 0;
  @Input() max = 99999999999;

}
